export default __webpack_public_path__ + "static/media/logo_sm_nigel.d5c91b52.svg";